/* eslint-disable camelcase */
import { initializeSegment, trackAction } from '@tcc/analytics';

import { ANALYTICS_LAYER_IDS } from '../constants/analyticsLayerIds';
import { FHA } from '../constants/mapLayerIds';
import { parseToUnderscore } from './strings';

/**
 * Initialize the TCC Analytics library. Set proxy variable.
 * @param {Number} clientId
 * @param {Boolean} isProxying
 * @param {String} fieldId
 * @return {void}
 */
export function initializeAnalytics(clientId) {
  initializeSegment(clientId);
}

/**
 * Process the results from getIdsFromHash to send the crop, layer, and year for analytics
 * @param {Object} hashValues
 * @return {Object}
 */
export function processLayerValues(hashValues) {
  const { mapLayerIds, seasonIds } = hashValues;

  const season = seasonIds.map((id) => (id.includes(':') ? id : null));
  const splitSeasonTags = seasonIds.map((id) => id.split(':'));

  const crop = splitSeasonTags.map((list) =>
    list.length > 1 ? list[1] : null
  );
  const year = splitSeasonTags.map((list) => list[0]);

  return {
    crop,
    layer: mapLayerIds.map(
      (layerName) => ANALYTICS_LAYER_IDS[layerName] || layerName
    ),
    season,
    year,
  };
}
export function getLayer(props) {
  const { hashValues, layerValues, layers } = props;

  let layer1 = null;
  let layer2 = null;
  if (hashValues.mapLayerIds[0] === 'fha') {
    const firstSubLayerKey =
      layers?.list[hashValues.seasonIds[0]].fha &&
      layers.list[hashValues.seasonIds[0]].fha.activeSubLayerIds[0].layer;
    const secondSubLayerKey = layers.list[hashValues.seasonIds[1]]
      ? layers.list[hashValues.seasonIds[1]].fha.activeSubLayerIds[1]?.layer
      : null;
    layer1 =
      firstSubLayerKey === FHA.SCOUTING
        ? ANALYTICS_LAYER_IDS[FHA.SCOUTING]
        : ANALYTICS_LAYER_IDS[FHA.VEGETATION];
    if (secondSubLayerKey) {
      layer2 =
        secondSubLayerKey === FHA.SCOUTING
          ? ANALYTICS_LAYER_IDS[FHA.SCOUTING]
          : ANALYTICS_LAYER_IDS[FHA.VEGETATION];
    }
  } else {
    [layer1] = layerValues.layer;
    layer2 = (layerValues && layerValues.layer[1]) || null;
  }
  return [layer1, layer2];
}

/**
 * Call TCC Analytics's trackEvent function with the desired event name and optional params
 * @param {String} noun
 * @param {String} verb
 * @param {Object} [params]
 * @return {void}
 */
export function trackEvent(noun, verb, params) {
  trackAction(
    `fieldview.mapbook.${parseToUnderscore(noun)}.${parseToUnderscore(verb)}`,
    Object.entries(params).reduce((acc, item) => {
      const [key, value] = item;
      acc[parseToUnderscore(key)] = value;
      return acc;
    }, {})
  );
}

/**
 * Returns the values of an activity necessary for tracking events
 * @param {Object} activity
 * @return {Object}
 */
export function getAnalyticsParamsFromActivity(activity) {
  return {
    color: activity.color,
    type: activity.permanent ? 'permanent' : 'seasonal',
    note:
      activity.comments &&
      activity.comments.length > 0 &&
      activity.comments[0].note,
    title: activity.title,
    photoAttached: activity.assets.map(({ uri }) => uri),
    tags: activity.tags,
    shape: activity.location && activity.location.type,
    longitude: activity.location && activity.location.coordinates[0],
    latitude: activity.location && activity.location.coordinates[1],
  };
}
